import TabsTriggerButton from './TabsTriggerButton';
import TabsTriggerContainer from './TabsTriggerContainer';

type TabsTriggerProps = {
  id: string;
  children: React.ReactNode;
  className?: string;
};
const TabsTrigger = ({ id, children, className }: TabsTriggerProps) => {
  return (
    <TabsTriggerContainer id={id}>
      <TabsTriggerButton id={id} className={className}>
        {children}
      </TabsTriggerButton>
    </TabsTriggerContainer>
  );
};

export default TabsTrigger;
